import { Injectable } from '@angular/core';
import { IPremium } from '../model/premium';
import { StorageBackedStore } from './storage-backed-store';

@Injectable({ providedIn : 'root'})
export class PremiumsStore extends StorageBackedStore<IPremium[]> {
    constructor() {
        super('premiums', []);
    }
}